import { resolveSourceChannel } from "@/hooks/useTheme";

export const CHECKOUT_FINISHED_PATH = "/checkout/finished";
export const CHECKOUT_AVULSO_SUCCESS_PATH = "/checkout/avulso-success";

export function getAvulsoSuccessHomeUrl(
  origin = typeof window === "undefined" ? "" : window.location.origin,
): string {
  return `${origin}/`;
}

export function getCheckoutSuccessPath(company?: string): string {
  if (resolveSourceChannel({ company }) === "site") {
    return CHECKOUT_AVULSO_SUCCESS_PATH;
  }

  return CHECKOUT_FINISHED_PATH;
}
